<script setup lang="ts">
import { useShortsHomeFeedJsonLd } from '~/composables/jsonLd/useShortsHomeFeedJsonLd';
import {
	SHORTS_LISTING_SURFACE_CONTRACT,
	useFetchShorts
} from '~/composables/shorts';
import { useShortsFilters } from '~/composables/useShortsFilters/useShortsFilters';
import { useShortsListingSeo } from '~/composables/useShortsListingSeo';

import { ShortsPage } from '~/components/ShortsPage';

// A primeira página do SSR alimenta a grade: pedir outro tamanho aqui faria a
// grade paginar em cima de uma sequência diferente da que ela mesma pede.
const { perPage: PAGE_SIZE, fetchOptions: FETCH_OPTIONS } =
	SHORTS_LISTING_SURFACE_CONTRACT;
const INITIAL_PAGE = 1;

definePageMeta({
	layout: 'shorts'
});

const {
	toShortsListingFeaturedVideosFilters,
	propertyTypes,
	hasActiveFilters,
	cities,
	regions,
	macroregions,
	states
} = useShortsFilters();
const { fetchVideos } = useFetchShorts();
const lastViewedPropertyCookie = useCookie<string>('last-viewed-property');

const { data: initialFetch } = await useAsyncData(
	`shorts-initial-seo:${lastViewedPropertyCookie.value || 'default'}`,
	() =>
		fetchVideos(
			toShortsListingFeaturedVideosFilters.value,
			INITIAL_PAGE,
			PAGE_SIZE,
			FETCH_OPTIONS
		)
);

const videos = computed(() => initialFetch.value?.items ?? []);
const totalAvailable = computed(
	() => initialFetch.value?.meta.totalAvailable ?? 0
);
const firstVideo = computed(() => videos.value[0] ?? null);

const shortsListingSeo = useShortsListingSeo(firstVideo, {
	propertyTypes,
	hasActiveFilters,
	totalAvailable,
	cities,
	regions,
	macroregions,
	states
});

useShortsHomeFeedJsonLd(() => videos.value, {
	pageTitle: () => shortsListingSeo.title.value,
	pageDescription: () => shortsListingSeo.description.value,
	pageUrl: () => shortsListingSeo.canonicalUrl.value
});
</script>

<template>
	<ShortsPage :initial-page="initialFetch" />
</template>
